const _ = require('underscore');

module.exports = {
  ..._,
  keys: theObj => Object.keys(theObj || {}),
  values: theObj => Object.values(theObj || {}),
  mapObject: (theObj, theFunction) => {
    const mappedObj = {};
    Object.keys(theObj || {}).forEach((k) => {
      mappedObj[k] = theFunction(theObj[k], k);
    });
    return mappedObj;
  },
  object: (keys, values) => {
    const result = {};
    keys.forEach((key, i) => { result[key] = values[i]; });
    return result;
  },
  all: _.every,
  any: _.some,
  contains: (theArray, theTarget) => (theArray || []).some(o => o === theTarget),
  difference: (a, b) => _.difference(a || [], b || []),
  each: (theArray, theFunction) => (theArray || []).forEach(theFunction),
  every: (theArray, theFunction) => (theArray || []).every(theFunction || (o => !!o)),
  filter: (theArray, theFunction) => (theArray || []).filter(theFunction || (o => !!o)),
  findWhere: (theArray, objMatcher) => (theArray || []).find(o =>
    Object.keys(objMatcher).every(k => o && o[k] === objMatcher[k])),
  intersection: (...arrays) => {
    const safeArrays = arrays.map(a => a || []);
    return _.intersection(...safeArrays);
  },
  map: (theArray, theFunction) => (theArray || []).map(theFunction || (o => o)),
  pluck: (theArray, theField) => (theArray || []).map(o => (o ? o[theField] : undefined)),
  rest: (theArray, count = 1) => (theArray || []).slice(count),
  some: (theArray, theFunction) => (theArray || []).some(theFunction || (o => !!o)),
  union: (...arrays) => {
    const safeArrays = arrays.map(a => a || []);
    return _.union(...safeArrays);
  },
  uniq: (theArray, maybeIsSorted, maybeIterator) => {
    if (maybeIterator) {
      return _.uniq(theArray, maybeIsSorted, maybeIterator);
    }
    return _.uniq(theArray);
  },
  where: (theArray, objMatcher) => (theArray || []).filter(o =>
    Object.keys(objMatcher).every(k => o[k] === objMatcher[k])),
};
